import { makeAutoObservable, runInAction } from 'mobx'
import moment, { Moment } from 'moment'
import EVInvoice from 'src/models/EVInvoice'
import * as apiClient from 'src/utils/apiClient/evInvoices'

///////////////////////////////////
// Types
///////////////////////////////////

const CACHE_SIZE = 10

type GetEVInvoiceParams = {
  userId: number
  date: Moment
}

///////////////////////////////////
// Store
///////////////////////////////////

export default class EVInvoiceStore {
  private invoiceCaches = new Map<string, EVInvoice>()

  invoiceDates: Moment[] = []

  constructor() {
    makeAutoObservable(this)
  }

  // Setter ------------------------------------------------------

  // Getter ------------------------------------------------------

  getInvoice = async ({ userId, date }: GetEVInvoiceParams) => {
    const cacheKey = this.cacheKey(date)
    const cache = this.invoiceCaches.get(cacheKey)
    if (cache) return cache

    const invoiceData = await apiClient.getInvoice({
      userId,
      year: date.year(),
      month: date.month() + 1,
    })

    const invoice = new EVInvoice(invoiceData)

    this.invoiceCaches.set(cacheKey, invoice)

    // キャッシュサイズを超えた場合、最も古いキャッシュを削除
    if (this.invoiceCaches.size > CACHE_SIZE) this.invoiceCaches.delete(this.invoiceCaches.keys().next().value)

    return invoice
  }

  getInvoiceDates = async (userId: number) => {
    const dates = await apiClient.getInvoiceDates({ userId })

    runInAction(() => {
      this.invoiceDates = dates.map((date) => moment(date))
    })
  }

  // Private actions ---------------

  private cacheKey = (date: Moment) => {
    return date.format('YYYY-MM')
  }
}
